@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<lib-dba-mat-table tableNameId="service" [data]="standortList" [columnsdef]="columnsdefMain" [importButton]="false"
    [editButton]="permissionService.serviceSchreiben" [createButton]="permissionService.serviceSchreiben"
    [deleteButton]="permissionService.serviceLoeschen" [dynamicSize]="true" [(selectedElement)]="selectedStandort"
    (openDialog2)="OpenDialog($event)" (deleteClicked)="deleteData($event[0].StandortID)">

        <lib-dba-mat-table-select [filter]="debitorFilter" [label]="language.debitor | translationPipe" labelProperty="Name"
        [list]="debitorfilteredList" [(value)]="selectedDebitor" [translate]="false">
    </lib-dba-mat-table-select>
</lib-dba-mat-table>